export type AppEnvironment = "development" | "test" | "staging" | "production";

export interface AppConfig {
  graphqlUrl: string;
  oidcUrl: string;
  apiTimeoutMs: number;
  environment: AppEnvironment;
}

function readEnv(key: keyof ImportMetaEnv, fallback: string): string {
  const value = import.meta.env[key];
  return typeof value === "string" && value.length > 0 ? value : fallback;
}

function parseEnvironment(raw: string): AppEnvironment {
  if (raw === "development" || raw === "test" || raw === "staging" || raw === "production") {
    return raw;
  }
  return "development";
}

export const appConfig: AppConfig = {
  graphqlUrl: readEnv("VITE_GRAPHQL_URL", "http://127.0.0.1:4000/graphql"),
  oidcUrl: readEnv("VITE_OIDC_URL", "http://127.0.0.1:8080/realms/nbs"),
  apiTimeoutMs: Number.parseInt(readEnv("VITE_API_TIMEOUT_MS", "30000"), 10) || 30_000,
  environment: parseEnvironment(readEnv("VITE_APP_ENV", "development")),
};
